// extracted by mini-css-extract-plugin
export default {"button":"XiXZi1","header":"BbeHxN","orderNumber":"Dg5QNH","placedOn":"WhJfrU","actions":"Nc08qe","link":"uJPE6y"};